import { Box } from '@mui/material'
import { FundingSummaryDto } from '@src/types/FundingSummaryDto'
import { useTranslation } from 'react-i18next'
import { InfoRow, SectionHeader } from './shared'

interface Props {
  fundingSummary: FundingSummaryDto
}

const IcebergMerchantInformation = ({ fundingSummary }: Props) => {
  const { t } = useTranslation()

  return (
    <Box>
      <SectionHeader>{t('fundingSummary.merchantInformation')}</SectionHeader>

      <InfoRow label={t('fundingSummary.paymentMethod')} value={t('fundingSummary.directDeposit')} />
      <InfoRow label={t('common.merchant')} value={fundingSummary?.merchantName} />
      <InfoRow label={t('fundingSummary.address')} value={fundingSummary?.merchantAddress} />
      <InfoRow label={t('fundingSummary.phone')} value={fundingSummary?.merchantPhone} />
    </Box>
  )
}

export default IcebergMerchantInformation
